<p>
  base-data-point-dialog works!
</p>
